import { render, staticRenderFns } from "./week.vue?vue&type=template&id=36daa9b2&"
import script from "./week.vue?vue&type=script&lang=js&"
export * from "./week.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports